import { Link } from "react-router-dom";

interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  status: string;
  views: number;
  rating: number;
}

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group cursor-pointer"
      data-product-shop
    >
      <div className="aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-100 relative">
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
          title={`${comic.title} - 免费下拉式漫画 - 布丁漫画网`}
        />
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
          {comic.rating}
        </div>
        {comic.status === "ongoing" && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500/90 text-xs font-medium text-background-50">
            连载
          </div>
        )}
        {comic.status === "completed" && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-secondary-500/90 text-xs font-medium text-background-50">
            完结
          </div>
        )}
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {comic.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span className="truncate">{comic.author}</span>
        <span>·</span>
        <span className="whitespace-nowrap">{(comic.views / 10000).toFixed(0)}万阅</span>
      </div>
    </Link>
  );
}